/* eslint-disable */
import { PluginContainerData } from './common';

export interface TableData {
  /** Styling for the table's container. */
  containerData?: PluginContainerData;
  /** The table's dimensions. */
  dimensions?: TableData_Dimensions;
  /**
   * Deprecated: Use `rowHeader` and `columnHeader` instead.
   *
   * @deprecated
   */
  header?: boolean;
  /** Sets whether the table's first row is a header. Defaults to `false`. */
  rowHeader?: boolean;
  /** Sets whether the table's first column is a header. Defaults to `false`. */
  columnHeader?: boolean;
}

export interface TableData_Dimensions {
  /** An array representing relative width of each column in relation to the other columns. */
  colsWidthRatio: number[];
  /** An array representing the height of each row in pixels. */
  rowsHeight: number[];
  /** An array representing the minimum width of each column in pixels. */
  colsMinWidth: number[];
}

const baseTableData: object = {};

export const TableData = {
  fromJSON(object: any): TableData {
    const message = { ...baseTableData } as TableData;
    message.containerData =
      object.containerData !== undefined && object.containerData !== null
        ? PluginContainerData.fromJSON(object.containerData)
        : undefined;
    message.dimensions =
      object.dimensions !== undefined && object.dimensions !== null
        ? TableData_Dimensions.fromJSON(object.dimensions)
        : undefined;
    message.header =
      object.header !== undefined && object.header !== null ? Boolean(object.header) : undefined;
    message.rowHeader =
      object.rowHeader !== undefined && object.rowHeader !== null
        ? Boolean(object.rowHeader)
        : undefined;
    message.columnHeader =
      object.columnHeader !== undefined && object.columnHeader !== null
        ? Boolean(object.columnHeader)
        : undefined;
    return message;
  },

  toJSON(message: TableData): unknown {
    const obj: any = {};
    message.containerData !== undefined &&
      (obj.containerData = message.containerData
        ? PluginContainerData.toJSON(message.containerData)
        : undefined);
    message.dimensions !== undefined &&
      (obj.dimensions = message.dimensions
        ? TableData_Dimensions.toJSON(message.dimensions)
        : undefined);
    message.header !== undefined && (obj.header = message.header);
    message.rowHeader !== undefined && (obj.rowHeader = message.rowHeader);
    message.columnHeader !== undefined && (obj.columnHeader = message.columnHeader);
    return obj;
  },
};

const baseTableData_Dimensions: object = { colsWidthRatio: 0, rowsHeight: 0, colsMinWidth: 0 };

export const TableData_Dimensions = {
  fromJSON(object: any): TableData_Dimensions {
    const message = { ...baseTableData_Dimensions } as TableData_Dimensions;
    message.colsWidthRatio = (object.colsWidthRatio ?? []).map((e: any) => Number(e));
    message.rowsHeight = (object.rowsHeight ?? []).map((e: any) => Number(e));
    message.colsMinWidth = (object.colsMinWidth ?? []).map((e: any) => Number(e));
    return message;
  },

  toJSON(message: TableData_Dimensions): unknown {
    const obj: any = {};
    if (message.colsWidthRatio) {
      obj.colsWidthRatio = message.colsWidthRatio.map(e => Math.round(e));
    } else {
      obj.colsWidthRatio = [];
    }
    if (message.rowsHeight) {
      obj.rowsHeight = message.rowsHeight.map(e => Math.round(e));
    } else {
      obj.rowsHeight = [];
    }
    if (message.colsMinWidth) {
      obj.colsMinWidth = message.colsMinWidth.map(e => Math.round(e));
    } else {
      obj.colsMinWidth = [];
    }
    return obj;
  },
};
